import axios from "axios";
const API_URL = `${process.env.REACT_APP_API_URL}/auth`; // Replace with your actual API URL


const customHeaders = {
    'Content-Type': 'application/json',
  };

 export const getAuth = async (data:{email:string,password:string}) =>{
    console.log(data,'data');
    
    const response = await axios.post(`${API_URL}/login`,data, { headers: customHeaders });
  return response.data;
  }